import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  getReturnsNotifications,
  getReturnsNotificationHistory90Days,
} from "../../services/notificationService";
import { postCustomerReturnRequest } from "../../services/deliveryService";

const QUERY_KEYS = {
  returnsNotifications: ["returnsNotifications"],
  historyReturnRequest: ["historyReturnRequest"],
};

export const useReturnsNotifications = () =>
  useQuery({
    queryKey: QUERY_KEYS.returnsNotifications,
    queryFn: getReturnsNotifications,
  });

// const fakePostCustomerReturnRequest = async (requestOrder) =>
//   new Promise((resolve) => {
//     setTimeout(() => {
//       console.log("requestOrder", requestOrder);
//       resolve(requestOrder);
//     }, 1000);
//   });

export const usePostCustomerReturnRequest = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: postCustomerReturnRequest,
    // mutationFn: fakePostCustomerReturnRequest,
  });

  const postSingleRequest = (requestOrder) => {
    mutation.mutate(requestOrder, {
      onSuccess: (_, variable) => {
        const isApproved = variable?.IsApproved;

        const message = `Return request has been ${
          isApproved ? "approved" : "rejected"
        } successfully`;

        toast.success(message);

        return queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.returnsNotifications,
        });
      },

      onError: (error, variable) => {
        const errorMessage = error?.response?.data?.message;

        const isApproved = variable?.IsApproved;

        const message = `Unexpected error occurred while ${
          isApproved ? "approving" : "rejecting"
        } the return order request`;

        toast.error(errorMessage || message);
      },
    });
  };

  const postBatchRequests = async (batchData, isApproveRequest) => {
    if (!batchData?.length) return;

    toast.info("Processing return order request, please wait...", {
      toastId: "return-order-request",
    });

    const statusesPromises = Promise.allSettled(
      batchData.map((data) => mutation.mutateAsync(data))
    );

    const statuses = await statusesPromises;

    if (batchData.length === statuses?.length) {
      toast.dismiss("return-order-request");

      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.returnsNotifications,
      });
    }

    if (statuses?.some((status) => status.status === "rejected")) {
      const numberOfFailed = statuses.filter(
        (status) => status.status === "rejected"
      ).length;

      toast.error(
        `${numberOfFailed}/${batchData.length} return ${
          isApproveRequest ? "approved" : "rejected"
        } requests failed`
      );
    }

    if (statuses?.some((status) => status.status === "fulfilled")) {
      const numberOfSuccess = statuses.filter(
        (status) => status.status === "fulfilled"
      ).length;

      toast.success(
        `Processed ${numberOfSuccess}/${batchData.length} return ${
          isApproveRequest ? "approved" : "rejected"
        } requests successfully`
      );
    }
  };

  return {
    mutation,
    postSingleRequest,
    postBatchRequests,
  };
};

// Noted Only that last 90 days of return request will be shown
export const useGetHistoryReturnRequest = () =>
  useQuery({
    queryKey: QUERY_KEYS.historyReturnRequest,
    queryFn: getReturnsNotificationHistory90Days,
  });
